import { Base } from '@or-sdk/base';
import { Migrations, } from './api';
import { AppError } from './AppError';
import { EKS_SERVICE_KEY } from './constants';
export class EKS extends Base {
    constructor(params) {
        super({
            token: params.token,
            discoveryUrl: params.discoveryUrl,
            serviceKey: EKS_SERVICE_KEY,
            accountId: params.accountId,
            serviceUrl: params.hitlEksUrl,
        });
        const request = this.callApiV2.bind(this);
        this.migrations = Migrations.configure(request);
    }
    parseError(e) {
        var _a;
        return new AppError((_a = e.response) === null || _a === void 0 ? void 0 : _a.data);
    }
}
export { AppError };
//# sourceMappingURL=EKS.js.map